export class ContactsVm {
        DatabaseID: number;
        OrganizationID: number;
        UserID: string;

        associatedContactID:number;
        
        CoreID:number;
        ContactID:number;
        CompanyID :number;

        CoreContactUserMapID:number;
        ContactContactUserMapID:number;       
        ContactCompanyUserMapID:number;

        CoreContactRoleID:number;
        ContactContactRoleID:number;
        ContactCompanyRoleID:number;

        AddUpdateCoreContactListModel:any=[];
        AddUpdateContactContactListModel :any=[];        
        AddUpdateCoreContactCompanyListModel: any=[];

        CoreContactRoleModels: any;
        ContactContactRoleModels: any;
        CoreContactCompanyRoleModels: any;
        OfficeID:any;
        IsAdded:boolean;
        sharedUserID:number;
}


export class ContactVm {
        DatabaseID: number;
        OrganizationID: number;
        UserID: string;
        PageIndex:number;
        PageSize:number;
        FolderId:number;
        transactionID:string;
        subFolderID:number;
        searchKey:string;
        contactID:number;
        userContactID: number;
        officeID:number;
        roleIDList: any=[];
        OfficeIDList: any;
        isArchived:boolean=false;
        isKanbanView:boolean=false;
}

export class AddContactVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        TransactionID:string;
        ContactID:number;
        Fields:Fields[];  
        FolderID:number;    
        ImageUrl:string; 
        TypeID:number;
        Tags: string;
        officeID:number=0;
        OfficeIDList:[];
        Status:string="";
}

export class ReorderColumnContactVm {
        UserID: string;
        FieldID:number;
        PreviousPosition:number;
        CurrentPosition:number;
        FolderID:number;
        OrganizationID: number;
        DatabaseID: number;     
  
}


export class UpdateColumnContactVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;       
        CustomizationGridUserSetting:CustomizationGridUserSetting[];
        officeID:number=0;
        OfficeIDList:[];     
}
export class Fields{
        FieldID:number;
        FieldName:string;
        FieldValue:string;           
    }

    export class CustomizationGridUserSetting{
        FieldID:number;
        FolderID:number;
        IsDisplay:boolean;    
        ViewOrder:number;       
    }

    export class FileContactModelVM{
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        Base64String:string; 
        FileName:string; 
        FileExtention:string;   
    }


    export class CreateContactFilterVm {
        userID: string;
        organizationID: number;
        databaseID: number;
        filterName:string;
        folderID:number;
        isDefault:boolean;
        isFavourite:boolean;   
        officeID:number;
        filterFieldsRequestModels:filterFieldsRequestModels[];
}

export class filterFieldsRequestModels{
        filterValue:string;
        childFieldType:number;
        fieldID:any;    
        fieldTypeID:number;  
        organizationID:number;     
    }

    export class FilteredContactVm {
        PageIndex:number;
        PageSize:number;
        UserID: string;
        FolderId:number;
        DatabaseID: number;
        OrganizationID: number;
        fields:fields[];
        searchValue:string;
        CoreID: number;
        ContactID:number;
        CompanyID:number;
        formID: number;
        formFolderID: any;
        userContactID: number;
        roleIDList:any=[];
        officeIDList: any=[];
        officeID:number=0;
        fileManagerItemID:number;
}

export class fields{
        filterFieldID:number;
        filterFieldValue:string;
        childFieldType:any;     
    }